export default "__VITE_ASSET__V3Y2dged__"